import {styled, Typography} from "@mui/material";
import dayjs, {Dayjs} from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {updateForm} from "store/actions/formAction";
import {findValue} from "./functions";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";

const InputContainer = styled("div")(({theme}) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
}));

const InputWrapper = styled("div")(({theme}) => ({
    padding: "2px 4px",
    border: `solid 2px #e6e6e6`,
    display: "flex",
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "space-between",
    height: "40px",
    width: "100%",
}));

const StyledTextField = styled(TextField)(({theme}) => ({
    width: "100%",
    ".MuiInputBase-root": {
        borderColor: "#e6e6e6",
        borderRadius: "4px",
        borderWidth: "2px",
        borderStyle: "solid",
        height: "40px",
    },
    "& fieldset": {
        border: "none !important",
    },
}));

export const TimeInput = ({name, label, required}: { name: string; label: string; required?: boolean }) => {
    // const [value, setValue] = useState<Dayjs | null>(
    //     dayjs('2014-08-18T21:11:54'),
    // );

    //@ts-ignore
    const formData = useSelector((state) => state).formReducer;
    //@ts-ignore
    const editItem = useSelector((state) => state.formReducer.editItem);

    const formType = "form";
    const dispatch = useDispatch();
    const defaultValue = editItem?.accessTimeLimit[name] || "";

    const value = findValue(formData, formType, name, editItem ? editItem[name] : defaultValue) || defaultValue;

    const handleChange = (newValue: Dayjs | null) => {
        // @ts-ignore
        return dispatch(updateForm(name, `${newValue["$H"]}:${newValue["$m"]}`));
    };

    return (
        <InputContainer>
            <Typography fontWeight="bold" variant="body2" sx={{marginBottom: "5px"}}>
                {label}&nbsp;{required ? "*" : ""}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                    value={dayjs(`2022-01-01T${value || "09:00"}`)}
                    onChange={handleChange}
                    // @ts-ignore
                    renderInput={(params) => <StyledTextField {...params} />}
                />
            </LocalizationProvider>
        </InputContainer>
    );
};

export default TimeInput;
